import HttpRequest from "@/util/HttpRequest";
import { normalizeEmployeeDocument, uniqueEmployeeDocuments, buildEmployeeYearStatistics } from "./employeeStatistics";

// 433/List.js의 기준일과 동일하게 계산한다.
export const employeeReferenceDate = (now = new Date()) => now.toISOString().split("T")[0];

export async function loadEmployeeDocuments(projectId, { activeOnly = false, referenceDate = employeeReferenceDate() } = {}) {
  const params = {
    projectId,
    perPage: 1000,
    orderTarget: "created_at",
    orderDirection: "desc",
    dateTarget: "created_at",
    draftMode: "include",
  };
  if (activeOnly) {
    params["conditions[0][key]"] = "body.retirement_date";
    params["conditions[0][operator]"] = ">n";
    params["conditions[0][value]"] = referenceDate;
  }

  const documents = [];
  let lastPage = 1;
  for (let page = 1; page <= lastPage; page++) {
    const response = await HttpRequest.get("/api/v1/board/post/433", { params: { ...params, page } });
    if (!response || !Array.isArray(response.data)) throw new Error("종사자 정보 문서 조회에 실패했습니다.");
    documents.push(...response.data.map(normalizeEmployeeDocument));
    lastPage = Number(response.last_page) || 1;
  }
  return uniqueEmployeeDocuments(documents);
}

// 상세 화면 인스턴스 안에서만 공유한다. 문서를 수정하고 재진입하면 새로 조회한다.
export function createEmployeeStatisticsSource(projectId, now = new Date()) {
  let pending = null;
  return {
    async loadYear(year) {
      if (!pending) {
        pending = Promise.all([
          loadEmployeeDocuments(projectId),
          loadEmployeeDocuments(projectId, { activeOnly: true, referenceDate: employeeReferenceDate(now) }),
        ]).catch((error) => {
          pending = null;
          throw error;
        });
      }
      const [documents, activeDocuments] = await pending;
      return buildEmployeeYearStatistics(documents, activeDocuments, year, now);
    },
  };
}
